import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'react-router';
import Auth from './views/auth';
import Dashboard from './views/dashboard';
import Header from './views/global/header';
import Footer from './views/global/footer';

export default class Container extends React.Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  componentDidMount() {
    window.push = this.context.router.history.push;
    if (process.env.REACT_APP_DISABLE_LOGIN === 'true') {
      localStorage.clear();
      this.context.router.history.push('/auth/login');
    }
  }

  render() {
    return (
      <div>
        <Route path="*" component={Header} />
        <div id="body">
          <div className="box">
            {process.env.REACT_APP_MESSAGE
              ? <section id="global">
                  <p>{process.env.REACT_APP_MESSAGE}</p>
                </section>
              : null}
            <Switch>
              <Route path="/auth" component={Auth} />

              <Route
                path="/"
                render={props =>
                  localStorage.getItem('token')
                    ? <Dashboard />
                    : window.location.pathname.match(/auth\//)
                        ? null
                        : <Redirect to={{ pathname: '/auth/login' }} />}
              />

              <Route component={() => <div>Not Found</div>} />
            </Switch>
            <Footer />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/container.js